import { AutocompleteSuggestionMatches } from '~/src/common/services/Google/types';

const highlightMatch = (text: string, matches: AutocompleteSuggestionMatches): string =>
  matches?.length
    ? matches
        .sort((a, b) => a.startOffset - b.startOffset)
        .reduce(
          (acc, { startOffset, endOffset }, i, arr) =>
            acc +
            text.slice(i ? arr[i - 1].endOffset : 0, startOffset) +
            `<span class="highlight">${text.slice(startOffset, endOffset)}</span>`,
          '',
        ) + text.slice(matches[matches.length - 1].endOffset)
    : text;

export default highlightMatch;
